<template>
  <BreadCrumb PageTitle="Détails de la session" />
  <ViewSession />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ViewSession from "@/components/Session/ViewSession.vue";

export default defineComponent({
  name: "ViewSessionPage",
  components: {
    BreadCrumb,
    ViewSession,
  },
});
</script>